module.exports = __webpack_public_path__ + "static/media/designPatent_30-1019486.4752b569.png";